import { render, staticRenderFns } from "./StatusDetail.vue?vue&type=template&id=0167ed12&scoped=true&"
import script from "./StatusDetail.vue?vue&type=script&lang=js&"
export * from "./StatusDetail.vue?vue&type=script&lang=js&"
import style0 from "./StatusDetail.vue?vue&type=style&index=0&id=0167ed12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0167ed12",
  null
  
)

export default component.exports